import http from '@/http/http';
import utils from '@/utils/utils'
import config from '@/config'

utils.logColor('sg_home_open_scene', 'red', sessionStorage.getItem('sg_home_open_scene'))
let scene = sessionStorage.getItem('sg_home_open_scene') ? sessionStorage.getItem('sg_home_open_scene') : ''
console.log('scene==>',scene)


// 活动配置
const getActivitidInfo = (params) => {
  let url = config.ADMINEHOST + '/cmsadmin/homepage/activity/getHomeActivityById.json?scene=' + scene 
  return http.get(url, {
    params,
  })
}
// 获取未读消息
const getUnreadMsgCount = () => http.get('/im/user/hasUnReadMsg?scene=' + scene, { noLogin: true })

// 首页各区域展示配置
const getHomeConfig = () => http.get('/sg/cms/homepage/findElementInfo.json?scene=' + scene)

// 分类tab配置
const getCategoryTab = () => http.get('/sg/cms/homepage/getCurrentActivitySlideTabByCurrentTime.json?scene=' + scene)

// 购物车列表
const getCartNumber = () => http.get(`/v3/h5/scart/num.json?scene=${scene}`)
// 背景信息
const getActivityBgInfo = () => http.get('/sg/cms/homepage/getCurrentActivityBackgroundByCurrentTime.json?scene=' + scene )
// banner
const getBanner = (params) => http.get('/sg/cms/home/banner.json?scene=' + scene, {
  params,
  // headers: { 'Platform': platform }
});
// search icon
const getTopSearchBar = () => {
  return http.get('/sg/cms/homepage/getCurrentActivityNavigationByCurrentTime.json?scene='+ scene)
}
// 分类
const getCategoryItems = () => {
  return http.get('/sg/cms/homepage/getCurrentActivityCategoryByCurrentTime.json?notSupportMPassFlag=1&scene='+scene);
}

// 金刚区
const getKingKongs = () => {
  return http.get('/sg/cms/homepage/getCurrentActivityVajraByCurrentTime.json?notSupportMPassFlag=1&scene='+scene)
}

// 优惠券
const getCouponList = (params) => {
  return http.get('/coupon/v1/carry/getCouponCenter.json?scene=' + scene, {
    params
  })
}
// 领取优惠券
const getCouponItem = (params) => {
  return http.get('/coupon/v1/carry/receiveCoupon.json?scene='+ scene, {
    params
  })
}

// 必选单品
const getProductRecommend = () => {
  return http.get(`/sg/cms/homepage/getAllHomeProductRecommend.json?scene=${scene}`)
}

// 场景
const getProgramData = () => {
  return http.get(`/sg/cms/home/uhome/getTabsByPageInfo.json?scene=${scene}`)
}

// 中通广告位
const getMiddleBanner = () => {
  return http.get('/sg/cms/homepage/getCurrentActivityAdvertByCurrentTime.json?scene=' + scene)
}

// 热门直播
const getHotLive = (params) => {
  return http.get('/sg/cms/live/getHotLive.json?scene=' + scene, {
    params
  });
}

// 营销区域
const getFlexArea = params => {
  return http.get(`/sg/cms/homepage/getCurrentActivityMarketingByCurrentTime.json?scene=${scene}`, { params })
}

// 是否展示优惠券
const getCouponStatus = params => {
  return http.get(`/sg/cms/homepage/getCurrentActivityCouponByCurrentTime.json?scene=${scene}`, { params })
}

// 限时抢购
const getFlashSale = (params) => {
  return http.get('/sg/cms/flashSales/fourth/nearFlashSale.json?scene='+scene, {
    params
  });
}

// 发现好货限时抢购
const getFlashSaleNew = (params, headers) => {
  return http.get('/api-gw/shpmResource/find/goods/query?scene='+scene, { params, headers, baseURL: config.UPLUSHOST });
}

// 附近店铺
const getNearbyShop = (params) => {
  // return http.post(`/sg/cms/home/nearbyStoreForHomeList.json`, params)
  return http.get(`/v3/mstore/decorate/getMallNearMdStore.json?scene=${scene}`, { params })
}

// 生态优选
const getelectricalGoods = (params) => {
  return http.get('/sg/cms/chara/charaIndex.json?scene='+scene, { params })
}

// 搜索词列表
const getDefaultSearchWord = (params) => {
  let url = '/search/defaultSearchList.json?platform=3&scene='+scene
  return http.get(url, {
    params,
    baseURL: config.SHOST,
  });
}

// 底部商品列表
const getCommonLoadItemNew = (params) => {
  let url = '/search/commonLoadItemNew.html'
  return http.get(url, { params, baseURL: config.SHOST, })
}
// 底部商品列表
const getPriceByProduct = (params) => {
  let url = '/search/getPriceByProductList.html'
  return http.get(url, { params, baseURL: config.SHOST, })
}

// 内容专区
const getLifeHomeList = (params, headers) => http.post('/scs/contents/v1/content/order/list', params, {
  headers,
  baseURL: config.UPLUSHOST
})

const getWaterfullTab = (params, headers) => http.get('/scs/commons/v1/recommend/classes', { params, headers, baseURL: config.UPLUSHOST })

// 底部千人千面瀑布流
const getWaterfullList = (params, headers, tab) => {
  let url = ''
  if(tab === 5) {
    url = '/api-gw/shpmResource/guessYouLike/query'
  }else{
    url = '/api-gw/shpmResource/waterfall/recommend/list'
  }
  return http.get(url, {
    params,
    headers: headers,
    baseURL: config.UPLUSHOST
  })
}

// 首页弹窗
const couponActivitysInfo = params => {
  return http.get(`/sg/cms/home/getCouponActivitys.json?scene=${scene}`, { params })
}

// 首页弹框领券
const receiveActivitysCoupons = params => {
  return http.get(`/sg/cms/home/receiveCoupons.json?scene=${scene}`, { params })
}
// 关闭弹框领券
const closeCouponPop = params => {
  return http.get(`/sg/cms/home/closeCouponPop.json?scene=${scene}`, { params })
}
export default {
  getHomeConfig,
  getActivitidInfo,
  getUnreadMsgCount,
  getCategoryTab,
  getCartNumber,
  getActivityBgInfo,
  getBanner,
  getTopSearchBar,
  getCategoryItems,
  getKingKongs,
  getCouponList,
  getCouponItem,
  getProductRecommend,
  getProgramData,
  getMiddleBanner,
  getHotLive,
  getFlexArea,
  getCouponStatus,
  getFlashSale,
  getFlashSaleNew,
  getNearbyShop,
  getelectricalGoods,
  getDefaultSearchWord,
  getCommonLoadItemNew,
  getPriceByProduct,
  getLifeHomeList,
  getWaterfullTab,
  getWaterfullList,
  couponActivitysInfo,
  receiveActivitysCoupons,
  closeCouponPop
}
